export default __webpack_public_path__ + "static/notosans-regular-webfont-cd66b030d53f94ca052762691a346716.ttf";